export { RecommendationsLayout } from './RecommendationsLayout';
